import {ReactComponent as PDF} from "../assets/PDF.svg";
import {ReactComponent as JPG} from "../assets/JPG.svg";
import {ReactComponent as PNG} from "../assets/PNG.svg";

const icons = {
    pdf: <PDF />,
    jpg: <JPG />,
    jpeg: <JPG />,
    png: <PNG />,
};

export default icons;
